
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogList from './components/BlogList';
import BlogCTA from './components/BlogCTA';

export default function BlogPage() {
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <BlogHero />
      <BlogList />
      <BlogCTA />
      <Footer />
    </div>
  );
}
